
const DEFAULT_DETAIL = {
  expiringSoonPoints: 0,
  total: 0,
  nickname: "",
  points: 0,
  validityValue: 14,
};

export default {
  name: "XcoinsPointsHero",
  props: {
    pointsDetail: {
      type: Object,
      default: null,
    },
  },
  computed: {
    isLogin() {
      return Boolean(this.$store.state.isLogin);
    },
    detail() {
      if (!this.isLogin) {
        return { ...DEFAULT_DETAIL };
      }

      const source =
        this.pointsDetail || this.$store.state.pointDetail || {};
      return {
        ...DEFAULT_DETAIL,
        ...source,
        validityValue: source.validityValue || DEFAULT_DETAIL.validityValue,
      };
    },
  },
  watch: {
    isLogin: {
      immediate: true,
      handler(loggedIn) {
        if (loggedIn && !this.pointsDetail) {
          this.fetchDetail();
        }
      },
    },
  },
  methods: {
    async fetchDetail() {
      if (!this.$pointsCache) {
        return;
      }

      await this.$pointsCache.ensurePointDetail();
    },
    formatPoints(value) {
      const number = Number(String(value || 0).replace(/,/g, ""));
      return Number.isFinite(number) ? number.toLocaleString("en-US") : value;
    },
    openLogin() {
      const useNewLogin =
        this.$store.state.siteConfig &&
        this.$store.state.siteConfig.DialogPassportSwitch == "1";
      if (useNewLogin) {
        this.$store.commit("OPEN_AUTH_MODAL", {
          tab: "login",
          redirectToUserCenter: false,
          source: {
            elementTypeName: "积分信息",
            clickName: "login",
            loginChannel: "积分信息",
          },
        });
      } else {
        this.$jumpTerminus(1);
      }
    },
  },
};
